import { render } from "./HeaderRikolto.vue?vue&type=template&id=476abd3e&scoped=true"
import script from "./HeaderRikolto.vue?vue&type=script&lang=js"
export * from "./HeaderRikolto.vue?vue&type=script&lang=js"

import "./HeaderRikolto.vue?vue&type=style&index=0&id=476abd3e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476abd3e"]])

export default __exports__